import type { SymbolMap } from '@mtg-deck-tool/shared';
import { parseManaCost, symbolToKey } from '@mtg-deck-tool/shared';

interface ManaCostIconsProps {
  manaCost: string;
  symbolMap: SymbolMap;
  size?: number;
  className?: string;
}

export function ManaCostIcons({ manaCost, symbolMap, size = 16, className = '' }: ManaCostIconsProps) {
  if (!manaCost) return null;
  const tokens = parseManaCost(manaCost);

  return (
    <span className={`inline-flex items-center gap-0.5 ${className}`}>
      {tokens.map((token, i) => {
        const svgUri = symbolMap[token];
        if (svgUri) {
          return (
            <img
              key={i}
              src={svgUri}
              alt={token}
              title={token}
              width={size}
              height={size}
              className="inline-block"
            />
          );
        }
        // Fallback: render raw symbol text
        const key = symbolToKey(token);
        return (
          <span
            key={i}
            className="inline-flex items-center justify-center rounded-full bg-gray-600 text-white font-bold"
            style={{ width: size, height: size, fontSize: size * 0.6 }}
          >
            {key}
          </span>
        );
      })}
    </span>
  );
}
